export const serializeFilterParams = (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== null) {
      if (value instanceof Date) {
        params.append(key, value.toISOString());
      } else {
        params.append(key, String(value));
      }
    }
  }

  let queryString = params.toString();

  if (queryString) {
    return `?${queryString}`;
  }

  return "";
};
